import { IFilterGroup, IFilterItem } from '../interfaces/shop';

const FILTER_GROUPS_DATA = {
  categories: {
    name: 'Categories',
    filters: [],
  } as IFilterGroup,
  byType: {
    name: 'By Type',
    filters: [],
  } as IFilterGroup,
  benefits: {
    name: 'Benefits',
    filters: [],
  } as IFilterGroup,
  shop: {
    label: 'shop',
    filterUrlPath: '/shop',
  } as IFilterItem,
};

export const FILTER_GROUP_CATEGORY_COLLECTION = [
  ...FILTER_GROUPS_DATA.categories.filters,
  ...FILTER_GROUPS_DATA.byType.filters,
];

export const FILTER_GROUP_BENEFITS_COLLECTION = [...FILTER_GROUPS_DATA.benefits.filters];

export const FILTER_GROUP_COLLECTION = [...FILTER_GROUP_CATEGORY_COLLECTION, ...FILTER_GROUP_BENEFITS_COLLECTION];

export const MOBILE_FILTER_GROUPS = {
  categories: 'categories',
  benefits: 'benefits',
};

export default FILTER_GROUPS_DATA;
